import React from 'react';
import './SButton.css';

export type SButtonSize = 'xs' | 'sm' | 'lg' | 'xl';
export type SButtonVariant = 'primary' | 'transparent' | 'outline' | 'disabled';

interface SButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: SButtonSize;
  variant?: SButtonVariant;
  /** Optional icon to render at the start of the button */
  icon?: React.ReactNode;
  /** Optional text label for the button */
  label?: string;
}

export const SButton: React.FC<SButtonProps> = ({
  size = 'sm',
  variant = 'primary',
  icon,
  label,
  className,
  disabled,
  ...buttonProps
}) => {
  const rootClassNames = [
    's-button-root',
    `s-button-size-${size}`,
    `s-button-variant-${variant}`,
    disabled || variant === 'disabled' ? 's-button-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const labelClassNames = [
    's-button-label',
    size === 'lg' ? 'body-sm-semibold' : size === 'xl' ? 'body-md-semibold' : 'body-sm',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={rootClassNames}
      disabled={disabled || variant === 'disabled'}
      {...buttonProps}
    >
      {icon && (
        <span className="s-button-icon">
          {icon}
        </span>
      )}
      {label && (
        <span className={labelClassNames}>
          {label}
        </span>
      )}
    </button>
  );
};

export default SButton;
